export default __webpack_public_path__ + "static/media/kitten3XS.adc0693d.webp";